//
import Model from '@/models/Model'

//
import AuthorizeModel from '@/models/Actions/AAuthorize'
import ConfirmPayModel from '@/models/Actions/AConfirmPay'
import RejectModel from '@/models/Actions/AReject'

//
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import DetailProviderPaymentSheet from '@/models/Purchase/PchDetailProviderPaymentSheet'

/**
 *
 */
export default class PchProviderPaymentSheet extends Model {
    //
    static includes = [
        'g_user.hr_employee',
        'g_authorizer_user.hr_employee',
        'pch_detail_provider_payment_sheets.debt_to_pays.pch_purchase_invoice',
        'pch_detail_provider_payment_sheets.pch_provider',
        'pch_detail_provider_payment_sheets.pch_provider_account_bank.g_bank',
        'pch_detail_provider_payment_sheets.pch_provider_account_bank.g_type_account_bank',
        'pch_detail_provider_payment_sheets.pch_provider_payment.pch_provider_account_movement',
        'pch_provider_payment_sheet_state',
    ]

    //
    downloadingExcel = false

    /**
     *
     */
    get can_authorize() {
        return this.pch_provider_payment_sheet_state_id === 1
    }

    /**
     *
     */
    get can_confirm() {
        return this.pch_provider_payment_sheet_state_id === 2
    }

    /**
     *
     */
    get can_edit() {
        return this.pch_provider_payment_sheet_state_id < 3
    }

    /**
     *
     */
    get can_excel() {
        return this.can_confirm || this.is_paid
    }

    /**
     *
     */
    get can_reject() {
        return this.pch_provider_payment_sheet_state_id === 1
    }

    /**
     *
     */
    get can_txt() {
        return this.can_confirm || this.is_paid
    }

    /**
     *
     */
    get can_update() {
        return this.pch_provider_payment_sheet_state_id === 1
    }

    /**
     * 
     */
    get export_name() {
        return `DETALLE_${ this.code }`
    }

    /**
     *
     */
    get g_user_hr_employee_full_name() {
        return [
            this.g_user.hr_employee.names,
            this.g_user.hr_employee.last_name1,
            this.g_user.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     *
     */
    get is_paid() {
        return this.pch_provider_payment_sheet_state_id === 4
    }

    /**
     *
     */
    get selected() {
        return this.pch_detail_provider_payment_sheets || []
    }

    /**
     *
     */
    set selected(items) {
        this.pch_detail_provider_payment_sheets = items.map(this.mapSelected)
    }

    /**
     *
     */
    get selected_total() {
        return this.selected.reduce(this.reduceTotal, 0)
    }

    /**
     *
     */
    get state() {
        return this.pch_provider_payment_sheet_state
    }

    /**
     *
     */
    get state_name() {
        return this.state ? this.state.state : '-'
    }

    /**
     *
     */
    authorize() {
        return this.hasMany(AuthorizeModel)
    }

    /**
     *
     */
    confirmPay() {
        return this.hasMany(ConfirmPayModel)
    }

    /**
     *
     */
    mapDetail = item => {
        return {
            pch_provider_account_bank_id: item.pch_provider_account_bank.id,
            debit_notes: [
                //{
                //    pch_debit_note_id: 0,
                //    amount_to_pay: 0,
                //},
            ],
            invoices: [
                {
                    pch_purchase_invoice_id:
                        item.debt_to_pays.pch_purchase_invoice_id,
                    amount_to_pay: item.amount_to_pay,
                },
            ],
        }
    }

    /**
     *
     */
    mapSelected = item => {
        //
        //console.log({ item })
        //
        switch (item.constructor) {
            case DetailProviderPaymentSheet:
                return item
            case PurchaseInvoiceModel:
                return this.mapSelectedInvoice(item)
            default:
                return this.mapSelectedObject(item)
        }
    }

    /**
     *
     */
    mapSelectedInvoice = item => {
        return new DetailProviderPaymentSheet({
            amount_to_pay: item.pch_provider_debt_to_pay.total,
            id: item.id,
            debt_to_pays: {
                pch_provider_account_id: null,
                pch_purchase_invoice_id: item.id,
                pch_purchase_invoice: item,
                total: item.pch_provider_debt_to_pay.total,
                total_paid: item.pch_provider_debt_to_pay.total_paid,
            },
            pch_provider: item.pch_provider,
            pch_provider_id: item.pch_provider_id,
            pch_provider_account_bank: item.pch_provider_account_bank,
            pch_provider_account_bank_id: item.pch_provider_account_bank_id,
        })
    }

    /**
     *
     */
    mapSelectedObject = item => {
        //
        const debt_to_pay = item.debt_to_pays.slice().pop()
        //
        return new DetailProviderPaymentSheet({
            ...item,
            id: debt_to_pay.pch_purchase_invoice_id,
            debt_to_pays: {
                ...debt_to_pay,
            },
        })
    }

    /**
     *
     */
    reduceTotal = (total, item) => total + item.amount_to_pay

    /**
     *
     */
    reject() {
        return this.hasMany(RejectModel)
    }

    /**
     *
     */
    reset() {
        //
        this.selected = this.pch_detail_provider_payment_sheets.map(
            this.mapSelected
        )

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'pch_provider_payment_sheet'
    }

    /**
     *
     */
    toAuthorize() {
        return this.clean(['g_user_id'])
    }

    /**
     *
     */
    toConfirm() {
        return this.clean(['g_user_id'])
    }

    /**
     *
     */
    toCreate() {
        //
        this.details = this.pch_detail_provider_payment_sheets.map(
            this.mapDetail
        )

        //
        return this.clean(['details', 'payment_date'])
    }

    /**
     *
     */
    toExcel() {
        return this.excel().then(this.showFile(this.code, 'xlsx'))
    }

    /**
     *
     */
    toTxt() {
        return this.txt().then(this.showFile(this.code, 'txt'))
    }

    /**
     *
     */
    toReject() {
        return this.clean(['g_user_id'])
    }

    /**
     *
     */
    toUpdate() {
        //
        this.details = this.pch_detail_provider_payment_sheets.map(
            this.mapDetail
        )

        //
        return this.clean(['details', 'id', 'payment_date'])
    }
}
